export default __webpack_public_path__ + "static/media/ec.c66983e9.svg";